import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-invoice-requests',
  templateUrl: './admin-invoice-requests.component.html',
  styleUrls: ['./admin-invoice-requests.component.css']
})
export class AdminInvoiceRequestsComponent {}
